exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".NoData___1okzv {\n  display: -ms-flexbox;\n  display: flex;\n  padding-top: 45%;\n  background: #F5F5F9;\n  font-family: PingFangSC-Regular, PingFang SC;\n  font-weight: 400;\n  color: #68758E;\n  line-height: 14px;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-align: center;\n      align-items: center;\n}\n.NoData___1okzv img {\n  width: 128px;\n  height: 128px;\n}\n", ""]);

// exports
exports.locals = {
	"NoData": "NoData___1okzv"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/components/NoData/index.less
// module id = 1139
// module chunks = 0